<template>
  <v-card>
    <v-toolbar card color="error" dark>
      <v-toolbar-title class="body-2">ELIMINAR PRODUCTOS</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="$emit('close')" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-form>
        <v-layout row wrap>
          <v-flex md12 xs12>
            <v-select
              :error-messages="errors.collect('laboratory')"
              :items="laboratories"
              data-vv-name="laboratory"
              label="Laboratorio"
              no-data-text="Datos no disponibles"
              required
              v-model="form.labID"
              v-validate="'required'"
            ></v-select>
          </v-flex>

          <v-flex md12 xs12>
            <v-alert :value="true" color="error" icon="warning" outline>
              Por favor sea cuidadoso, se eliminaran todos los productos del
              laboratorio seleccionado.
            </v-alert>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-card-actions class="pb-3">
      <v-spacer></v-spacer>
      <v-btn @click="deleteAll" color="error">Eliminar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    laboratories: [],
    form: {
      labID: '',
    },
  }),
  created() {
    this.$store.dispatch('laboratories/getAll', {}).then(response => {
      const data = response.items
      for (let index = 0; index < data.length; index += 1) {
        this.laboratories.push({
          text: data[index].name,
          value: data[index].id,
        })
      }
    })
  },
  methods: {
    deleteAll() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit('close')
          this.$emit('loading-show')
          this.$store
            .dispatch('products/deleteAll', this.form)
            .then(response => {
              this.$emit('delete-ready', response.data.status)
            })
        }
      })
    },
  },
}
</script>
